module.exports = __webpack_public_path__ + "img/1.8606a806.png";